const cacheApiList = {
  "/api/v1/central/setting": 600 * 1000,
  "/api/v1/taxonomy/category": 300 * 1000,
  "/api/v1/notification/record": 60 * 1000,
  "/api/v1/user/profile/user_config": 60 * 1000,
};

export default cacheApiList;
